import { makeStyles } from '@fluentui/react-components';

import { palette, tokens } from '../../theme';

// Coloured dot + label + count. Dot colours match the calendar cells.
export const CountChip: React.FC<{ color: string; label: string; count: number }> = ({ color, label, count }) => {
    const classes = useStyles();
    return (
        <span className={classes.chip}>
            <span className={classes.dot} style={{ backgroundColor: color }} />
            <span className={classes.label}>{label}</span>
            <span className={classes.number}>{count}</span>
        </span>
    );
};

// Two columns with counts aligned across rows.
export const useCountChipGridStyles = makeStyles({
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        rowGap: '22px',
        columnGap: '12px',
    },
});

const useStyles = makeStyles({
    chip: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '13px',
        minWidth: 0,
    },
    dot: {
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        flexShrink: 0,
    },
    label: {
        color: tokens.colorNeutralForeground1,
        fontWeight: tokens.fontWeightSemibold,
        // Reserve enough width for the longest label so counts align vertically
        // across rows within the same column.
        minWidth: '68px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    number: {
        fontSize: '13px',
        fontWeight: tokens.fontWeightRegular,
        color: palette.dimText,
        fontVariantNumeric: 'tabular-nums',
    },
});
